import { COMPANY } from "@/config/company";

// Per-page SEO metadata. Uses React 19's native document-metadata support: <title>, <meta> and <link>
// rendered here are hoisted into <head>, and JSON-LD is read by Google wherever it sits in the document.
// Give every public page its own <Seo> so each has a unique title, description and canonical URL.
const BASE = COMPANY.website.replace(/\/$/, ""); // https://www.sendtoo.in

export default function Seo({ title, description, path = "/", image, noindex = false, jsonLd }) {
  const url = BASE + (path === "/" ? "/" : path.replace(/\/$/, ""));
  const img = image || `${BASE}/sendtoo-logo.png`;
  const fullTitle = title ? `${title} | Sendtoo - Bharat Courier Point` : "Sendtoo - Bharat Courier Point | Courier, Cargo & Logistics in Visakhapatnam";
  const desc = description || "Sendtoo - courier, cargo and logistics across South India and all of India.";
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Sendtoo" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />
      ))}
    </>
  );
}

// Site-wide Organization + LocalBusiness schema (emitted once, from PublicLayout). Real NAP from COMPANY.
export const organizationSchema = () => {
  const addr = {
    "@type": "PostalAddress",
    streetAddress: "D No. 50-81-24/12, GVK Plaza, Seethammapeta Main Road",
    addressLocality: "Visakhapatnam",
    addressRegion: "Andhra Pradesh",
    postalCode: "530016",
    addressCountry: "IN",
  };
  return [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Sendtoo - Bharat Courier Point",
      alternateName: ["Sendtoo", "Bharat Courier Point"],
      legalName: COMPANY.legalName,
      url: BASE,
      logo: `${BASE}/sendtoo-logo.png`,
      email: COMPANY.email,
      telephone: COMPANY.phoneTel,
      address: addr,
      identifier: [
        { "@type": "PropertyValue", propertyID: "CIN", value: COMPANY.cin },
        { "@type": "PropertyValue", propertyID: "GSTIN", value: COMPANY.gstin },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${BASE}/#localbusiness`,
      name: "Sendtoo - Bharat Courier Point",
      image: `${BASE}/sendtoo-logo.png`,
      url: BASE,
      telephone: COMPANY.phoneTel,
      email: COMPANY.email,
      priceRange: "₹₹",
      address: addr,
      areaServed: [
        { "@type": "State", name: "Andhra Pradesh" },
        { "@type": "State", name: "Telangana" },
        { "@type": "Country", name: "India" },
      ],
    },
  ];
};
